import type { IRoleActions } from '@/hooks/role-actions';

import type { IPermissionSnapshot } from './types';

/**
 * Adapt a permission snapshot into the shape `RoleActionContext` publishes.
 *
 * Shared by the real hook, the Storybook provider, the test renderer and the
 * "view as role" preview — so a previewed permission set is provably the same shape
 * the app runs on, rather than a parallel approximation of it.
 */
export const toRoleActionsValue = (snapshot: IPermissionSnapshot, isLoading = false): IRoleActions => ({
	allRoleActions: [...snapshot.actions],
	isAllowedRoles: snapshot.actions,
	isLoading,
	snapshot,
	source: snapshot.source,
	isResolved: snapshot.isResolved,
	roles: snapshot.roles,
	can: (action) => snapshot.actions.has(action),
	canAny: (actions) => actions.some((action) => snapshot.actions.has(action)),
	canAll: (actions) => actions.length > 0 && actions.every((action) => snapshot.actions.has(action)),
});
